import {
  BriefcaseIcon as DashboardIcon,
  ChatBubbleBottomCenterIcon as QuestionIcon,
  LinkIcon as IntegrationIcon,
  InboxIcon as FormIcon,
  FunnelIcon as FunnelIcon,
  UserCircleIcon as SegmentIcon,
  GiftIcon as CtaIcon,
  PuzzlePieceIcon as WidgetIcon,
  DocumentIcon as PagesIcon,
  WindowIcon as PersonalizationIcon,
  AtSymbolIcon as EmailIcon,
  BoltIcon as GoalIcon,
  ChartBarIcon as FunnelAnalysisIcon,
  BookOpenIcon as TemplatesIcon,
  ChatBubbleLeftRightIcon as SupportIcon,
  PresentationChartLineIcon as TestingIcon,
  FingerPrintIcon as AttributionIcon,
  CheckBadgeIcon as ChecklistIcon,
  UserGroupIcon as LeadsIcon,
  LightBulbIcon as AutoPersonalizeIcon
} from '@heroicons/vue/24/outline'

const generateNavigation = computed(() => {
  const integrationStore = useIntegrationStore()
  const { integratedPartner } = storeToRefs(integrationStore)

  const onboardingStore = useOnboardingStore()
  const { isOnboarded } = storeToRefs(onboardingStore)

  const localDevelopment = import.meta.env.VITE_APP_ENV === 'development'

  return [
    {
      name: 'Dashboard',
      to: { name: ROUTES.DASHBOARD },
      icon: DashboardIcon
    },
    {
      name: 'People',
      to: { name: ROUTES.PEOPLE },
      icon: LeadsIcon
    },
    {
      name: 'Enrich',
      type: 'divider'
    },
    {
      name: 'Segment Groups',
      to: { name: ROUTES.SEGMENTGROUPS },
      icon: SegmentIcon
    },
    {
      name: 'Questions',
      to: { name: ROUTES.QUESTIONS },
      icon: QuestionIcon
    },
    {
      name: 'Attribution',
      to: { name: ROUTES.ATTRIBUTION },
      icon: AttributionIcon
    },
    {
      name: 'Integration',
      to: { name: ROUTES.INTEGRATIONS },
      icon: IntegrationIcon,
      aside: integratedPartner.value
        ? `<img src="${integratedPartner.value.logo}" class="h-3.5 max-w-[70px] opacity-50 grayscale dark:invert" />`
        : ''
    },
    {
      name: 'Convert',
      type: 'divider'
    },
    {
      name: 'Flows',
      to: { name: ROUTES.OFFERFUNNELS },
      icon: FunnelIcon
    },
    {
      name: 'Widgets',
      to: { name: ROUTES.WIDGETS },
      icon: WidgetIcon
    },
    {
      name: 'Pages',
      to: { name: ROUTES.PAGES },
      icon: PagesIcon,
      comingsoon: true
    },
    {
      name: 'Forms',
      to: { name: ROUTES.FORMS },
      icon: FormIcon
    },
    {
      name: 'Offers & Promos',
      to: { name: ROUTES.OFFERS },
      icon: CtaIcon
    },
    {
      name: 'Personalization',
      type: 'divider'
    },
    {
      name: 'Emails',
      to: { name: ROUTES.EMAILS },
      icon: EmailIcon,
      beta: false
    },
    {
      name: 'Website',
      to: { name: ROUTES.CAMPAIGNS },
      icon: PersonalizationIcon
    },
    {
      name: 'Conversion Goals',
      to: { name: ROUTES.GOALS },
      icon: GoalIcon
    },
    {
      name: 'Auto Personalize',
      href: '#',
      icon: AutoPersonalizeIcon,
      comingsoon: true
    },
    // {
    //   name: 'Phrases',
    //   to: { name: ROUTES.GOALS },
    //   icon: shallowRef(PhraseIcon)
    // },
    { name: 'Optimize', type: 'divider' },
    {
      name: 'Audience Insights',
      to: { name: ROUTES.INSIGHTS },
      icon: TemplatesIcon
    },
    {
      name: 'A/B Testing',
      to: { name: ROUTES.SPLIT_TESTS },
      icon: TestingIcon
    },
    {
      name: 'Review Session',
      to: { name: ROUTES.REVIEW_SESSION },
      icon: SupportIcon
    }
  ]
})

const generateUserNavigation = () => {
  const router = useRouter()
  const route = useRoute()
  const authStore = useAuthStore()
  const { user } = storeToRefs(authStore)

  const items = [
    {
      name: 'Your profile',
      action: () => {
        router.push({ name: ROUTES.PROFILE, query: { tab: 'profile' } })
      }
    },
    {
      name: 'Projects',
      action: () => router.push({ name: ROUTES.PROFILE, query: { tab: 'projects' } })
    }
  ]

  // Add Agency menu item only for agency users
  if (user.value?.is_agency) {
    items.push({
      name: 'Agency',
      action: () => router.push({ name: ROUTES.PROFILE, query: { tab: 'agency-clients' } })
    })
  }

  items.push(
    {
      name: 'Billing',
      action: () => router.push({ name: ROUTES.PROFILE, query: { tab: 'billing' } })
    },
    { name: 'Sign out', action: () => (window.location.href = '/logout') }
  )

  return items
}

export { generateNavigation, generateUserNavigation }
